import type { ComponentType } from 'react';

import AccountLockedDialog from '../components/Dialogs/AccountLockedDialog/AccountLockedDialog';
import ChooseCountry from '../features/auth/ChooseCountryDialog/ChooseCountry';
import SomethingWentWrongDialog from '../features/auth/SomethingWentWrongDialog/SomethingWentWrongDialog';
import WelcomeBonusDialog from '../features/auth/WelcomeBonusDialog/WelcomeBonusDialog';
import DirectRegWizard from '../features/auth/wizards/DirectRegWizard';
import LogInWizard from '../features/auth/wizards/LogInWizard';
import ResetPasswordWizard from '../features/auth/wizards/ResetPasswordWizard';
import SignUpWizard from '../features/auth/wizards/SignUpWizard';

import { componentsRegistry } from './componentsRegistry';

export const registerAuthComponents = () => {
  componentsRegistry.registerComponent('logInWizard', LogInWizard);
  componentsRegistry.registerComponent('signUpWizard', SignUpWizard);
  componentsRegistry.registerComponent('resetPasswordWizard', ResetPasswordWizard);
  componentsRegistry.registerComponent('directRegWizard', DirectRegWizard);
  componentsRegistry.registerComponent('WelcomeBonusDialog', WelcomeBonusDialog);
  componentsRegistry.registerComponent('ChooseCountry', ChooseCountry);
  componentsRegistry.registerComponent('somethingWentWrongDialog', SomethingWentWrongDialog as ComponentType);
  componentsRegistry.registerComponent('accountLockedDialog', AccountLockedDialog);
};
